export type ProductType = 'data-storage' | 'monitoring' | 'visualisation' | 'collaboration';

export type Product = {
  type: ProductType;
  name: string;
  to: string;
  icon: string;
  description: string;
};

export const products: Product[] = [
  {
    type: 'data-storage',
    name: 'Data Storage',
    to: '/products/data-storage',
    icon: 'cloud',
    description:
      // eslint-disable-next-line @stylistic/max-len
      'Simplified cloud storage - manage all your project files: drawings, models, plans and more. CDEasy',
  },
  {
    type: 'visualisation',
    name: 'Visualisation',
    to: '/products/visualisation',
    icon: 'deployed_code',
    description: 'Combine CAD, BIM, Point Clouds and plans - all in the browser',
  },
  {
    type: 'collaboration',
    name: 'Collaborate & Annotate',
    to: '/products/collaborate-annotate',
    icon: 'forum',
    description: 'Share, comment, mark up and work live with teams, clients, and contractors',
  },
  {
    type: 'monitoring',
    name: 'Monitoring',
    to: '/products/monitoring',
    icon: 'monitoring',
    description:
      // eslint-disable-next-line @stylistic/max-len
      'You survey, we display. Capture, visualise and share live data from land, buildings, highways and rail',
  },
] as const;
